import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function EditClassModal({ event, cancelModal, refreshData }) {
  const { user } = useAuthContext();
  const [name, setName] = useState("");
  const [nameErr, setNameErr] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionErr, setDescriptionErr] = useState("");
  const [day, setDay] = useState("");
  const [timeIn, setTimeIn] = useState("");
  const [timeInErr, setTimeInErr] = useState("");
  const [timeOut, setTimeOut] = useState("");
  const [timeOutErr, setTimeOutErr] = useState("");
  const [oneOff, setOneOff] = useState(false);
  const [price, setPrice] = useState("");
  const [priceErr, setPriceErr] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [bookingCapacity, setBookingCapacity] = useState(0);
  const nameRegex = /^[a-zA-Z0-9 ]+$/;

  const checkValiations = () => {
    setNameErr("");
    setDescriptionErr("");
    setTimeInErr("");
    setTimeOutErr("");
    setPriceErr("")
    let error = false;

    //price Validation
    if (price > 50) {
      error = true;
      setPriceErr("The price must not exceed £50");
  } else if (price > 0 && price < 1) {
      error = true;
      setPriceErr("The price must be at least £1");
  }

    //Name Validations
    if (name.length > 60) {
      error = true;
      setNameErr("Name is too long");
    }
    if (!nameRegex.test(name)) {
      error = true;
      setNameErr("The Name can only include letters, spaces");
    }
    //Description Validations
    if (name.description > 3000) {
      error = true;
      setDescriptionErr("Name is too long");
    }
    //TimeIn Validation
    if (timeIn > timeOut) {
      error = true;
      setTimeInErr("Time in must not be greater than the time out");
    }
    if (timeIn == "") {
      error = true;
      setTimeInErr("Time in required");
    }
    if (timeOut == "") {
      error = true;
      setTimeOutErr("Time out required");
    }

    if(!error){
      setCheckConfirm(true)
    }
  };

  //styled
  const convertTimeToInt = (time) => {
    return parseInt(time.replace(":", ""), 10);
  };

  function convertIntToTimeInputFormat(timeInt) {
    // Convert the integer to a string and pad with leading zeros if necessary
    let timeString = timeInt.toString().padStart(4, "0");

    // Ensure the input is a 4-digit string
    if (timeString.length !== 4 || isNaN(timeString)) {
      throw new Error("Invalid time format");
    }

    // Extract the hours and minutes from the string
    let hours = timeString.substring(0, 2);
    let minutes = timeString.substring(2, 4);

    // Format the time in HH:MM format
    return `${hours}:${minutes}`;
  }

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const eventResponse = await axios.get(
          `${ApiConnectionString}/api/event/${event.id}`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );
        if (eventResponse.status === 200) {
          setName(eventResponse.data.name);
          setDescription(eventResponse.data.description);
          setDay(eventResponse.data.day);
          setTimeIn(convertIntToTimeInputFormat(eventResponse.data.timeIn));
          setTimeOut(convertIntToTimeInputFormat(eventResponse.data.timeOut));
          setPrice(eventResponse.data.price / 100);

          setBookingCapacity(
            eventResponse.data.bookingCapacity !== null
              ? eventResponse.data.bookingCapacity
              : 0
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setIsLoading(false);
    };

    fetchData();
  }, [user]);

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    const updateEvent = {
      id: event.id,
      name,
      description,
      timeIn: convertTimeToInt(timeIn),
      timeOut: convertTimeToInt(timeOut),
      price: price * 100,
      bookingCapacity,
    };

    try {
      const updateResponse = await axios.put(
        `${ApiConnectionString}/api/event`,
        updateEvent,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (updateResponse.status === 200) {
        setComplete(true);
        setCheckConfirm(false);
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  }
  if (checkConfirm) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Confirm Changes</p>
          </div>

          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <table>
            <tbody>
              <tr>
                <td className="red-text fw-bold">
                  <label htmlFor="name">Class Name:</label>
                </td>
                <td>
                  <p>{name}</p>
                </td>
              </tr>
              <tr>
                <td className="red-text fw-bold">
                  <label htmlFor="description">Subtitle:</label>
                </td>
                <td>
                  <p>{description}</p>
                </td>
              </tr>
              <tr>
                <td className="red-text fw-bold">
                  <label htmlFor="timeIn">Time In:</label>
                </td>
                <td>
                  <p>{timeIn}</p>
                </td>
              </tr>
              <tr>
                <td className="red-text fw-bold">
                  <label htmlFor="timeOut">Class Capacity:</label>
                </td>
                <td>
                  <p>{bookingCapacity}</p>
                </td>
              </tr>

              <tr>
                <td className="red-text fw-bold">
                  <label htmlFor="timeOut">Time Out:</label>
                </td>
                <td>
                  <p>{timeOut}</p>
                </td>
              </tr>

              <tr>
                <td className="red-text fw-bold">
                  <label>Price (£):</label>
                </td>
                <td>
                  <p>{price}</p>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="send-modal-footer">
            <button className="saveChanges-button mx-3" onClick={handleSubmit}>
              Confirm
            </button>
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  } else if (complete) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Class Updated</p>
          </div>

          <button
            type="button"
            className="close-button"
            onClick={() => {
              refreshData();
              cancelModal();
            }}
            aria-label="Close"
          >
            &times;
          </button>
          <p>The class has been updated successfully.</p>
          <div className="send-modal-footer">
            <button
              onClick={() => {
                refreshData();
                cancelModal();
              }}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Edit Class</p>
          </div>

          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <div>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="name">Class Name:</label>
                    </td>
                    <td>
                      <input
                        type="text"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </td>
                  </tr>
                  {nameErr && <p className="text-danger">{nameErr}</p>}
                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="description">Subtitle:</label>
                    </td>
                    <td>
                      <textarea
                        id="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        required
                      />
                    </td>
                  </tr>
                  {descriptionErr && (
                    <p className="text-danger">{descriptionErr}</p>
                  )}
                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="timeIn">Time In:</label>
                    </td>
                    <td>
                      <input
                        type="time"
                        id="timeIn"
                        value={timeIn}
                        onChange={(e) => setTimeIn(e.target.value)}
                        required
                      />
                    </td>
                  </tr>
                  {timeInErr && <p className="text-danger">{timeInErr}</p>}
                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="timeOut">Time Out:</label>
                    </td>
                    <td>
                      <input
                        type="time"
                        id="timeOut"
                        value={timeOut}
                        onChange={(e) => setTimeOut(e.target.value)}
                        required
                      />
                    </td>
                  </tr>
                  {timeOutErr && <p className="text-danger">{timeOutErr}</p>}
                  <tr>
                    <td className="red-text fw-bold">
                      <label htmlFor="price">Class Capacity: </label>
                    </td>
                    <td>
                      <input
                        type="number"
                        id="classLimit"
                        name="classLimit"
                        pattern="^\d*$"
                        inputMode="numeric"
                        value={bookingCapacity}
                        onChange={(e) => {
                          const value = e.target.value;
                          // Optionally validate the value or ignore invalid input
                          if (/^\d*$/.test(value)) {
                            setBookingCapacity(value);
                          }
                        }}
                      />
                      <p className="text-muted">
                        How many people can attend this at one time? If there is
                        no limit, leave it as zero.
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td className="red-text fw-bold">
                      <label>Price (£)</label>
                    </td>
                    <td>
                      <input
                        type="number"
                        step="0.01"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        required
                      />
                    </td>
                  </tr>
                  {priceErr && <p className="text-danger">{priceErr}</p>}
                </tbody>
              </table>

              {!oneOff && (
                <div>
                  <p>The day of the class can not be changed.</p>
                </div>
              )}

              <button
                onClick={checkValiations}
                className="saveChanges-button"
              >
                Update
              </button>
            </div>
          </div>
          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}
